import { Directive, ElementRef, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Directive({
  selector: '[appSubmitIfValid]'
})
export class SubmitIfValidDirective {

  @Input('appSubmitIfValid') fromRef: FormGroup;
  @Input('validationOnClick') validationOnClick = false;
  @Input('cancelEnabled') cancelEnabled = true;
  @Input('submitEnabled') submitEnabled = true;
  @Output() valid = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<HTMLElement>();

  constructor() {
  }

  @HostListener('click')
  public handleClick() {
    if (this.submitEnabled && this.validationOnClick) {
      this.markFieldAsDirty();
      this.evalIfValid();
    }
  }

  @HostListener('document:keydown', ['$event', '$event.target'])
  public onKeyDown(event: KeyboardEvent, targetElement: HTMLElement): void {

    if (this.cancelEnabled && event.key === 'Escape') {
      this.cancel.emit(targetElement);
      return;
    }

    if (this.submitEnabled && event.key === 'Enter') {
      this.markFieldAsDirty();
      this.evalIfValid();
      return;
    }
  }

  private markFieldAsDirty() {
    if (this.fromRef) {
      Object.keys(this.fromRef.controls)
        .forEach(fieldName => this.fromRef.controls[fieldName].markAsDirty());
    }
  }

  private evalIfValid() {
    if (!this.fromRef || this.fromRef.valid) {
      this.valid.emit();
    } else {
      Object.keys(this.fromRef.controls)
        .forEach(fieldName => this.fromRef.controls[fieldName].markAsTouched());
    }
  }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/directives/submit-if-valid.directive.ts